<template>
  <v-row v-if="properties != null" align="center" justify="center">
    <v-col
      cols="12"
      md="2"
      v-if="properties.image != null && properties.title != null"
    >
      <v-avatar class="large-card-avatar" :size="computeImageSize">
        <CImage :url="properties.image" :size="computeImageSize"></CImage>
      </v-avatar>
    </v-col>
    <v-col cols="12" md="10">
      <div>
        <v-card-title v-if="properties.title != null" class="large-card-title">
          <span>{{ properties.title }}</span>
        </v-card-title>
        <v-card-subtitle
          v-if="properties.subtitle != null"
          class="large-card-subtitle"
          >{{ properties.subtitle }}</v-card-subtitle
        >
        <v-card-text v-if="properties.text != null">
          <template v-for="(elem, id) in properties.text">
            <CText
              class="mt-3"
              :text="elem"
              :key="id"
              :text_type="text_type"
              :color_text="text_color"
            />
          </template>
        </v-card-text>
        <div v-if="properties.list != null">
          <CList
            :list="properties.list"
            :color="this.$vuetify.theme.themes.light.blue_6"
          />
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import CImage from "@/components/HomeSections/SubComponents/Image";
import CList from "@/components/HomeSections/SubComponents/List";

export default {
  name: "LargeCard",
  components: {
    CImage,
    CList
  },
  data: () => ({
    text_color: "medium_grey",
    text_type: "simple_text"
  }),
  props: {
    properties: {
      type: Object,
      default: null
    },
    image_contained: {
      type: Boolean,
      default: false
    },
    variant_color: {
      type: Boolean,
      default: false
    }
  },
  methods: {},
  computed: {
    computeImageSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "140";
        case "sm":
          return "140";
        case "md":
          return "140";
        case "lg":
          return "180";
        default:
          return "180";
      }
    }
  }
};
</script>

<style scoped>
.square-contained {
  max-width: 100%;
  width: auto !important;
  height: auto !important;
  vertical-align: middle;
}

.large-card-title {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #243b53 !important;
}

.large-card-subtitle {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #486581 !important;
}

.large-card-avatar {
  border: 1px solid #fafefe;
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  display: block;
  margin: auto;
}

.text {
  margin: 10px 0px;
}
</style>
